import AgentFields from './AgentFields'
import TaskFields from './TaskFields'
import CustomEntityEntryFields from './CustomEntityEntryFields'
import LocationFields from './LocationFields'
import ItemFields from './ItemFields'
import ServiceLocalItemFields from './ServiceLocalItemFields'

const Factory = {

  registeredTypes: new Map(),

  register(clazzName, clazz) {
      this.registerFields(clazzName, clazz, AgentFields)
      this.registerFields(clazzName, clazz, TaskFields)
      this.registerFields(clazzName, clazz, CustomEntityEntryFields)
      this.registerFields(clazzName, clazz, LocationFields)
      this.registerFields(clazzName, clazz, ItemFields)
      this.registerFields(clazzName, clazz, ServiceLocalItemFields)
  },

  registerFields(clazzName, clazz, instance) {
    if (!(this.registeredTypes.has(clazzName) &&
      clazz.prototype instanceof instance)) {
        this.registeredTypes.set(clazzName, clazz);
    }
  },

  create(clazzName) {
      if (!this.registeredTypes.has(clazzName)) { 
          console.error(`Entity ${clazzName} doesn't exists`);
          return null;
      } 
      let clazz = this.registeredTypes.get(clazzName);
      return new clazz();
  }
}

Factory.register('agent', AgentFields)
Factory.register('task', TaskFields)
Factory.register('customEntityEntry', CustomEntityEntryFields)
Factory.register('location', LocationFields)
Factory.register('item', ItemFields)
Factory.register('serviceLocalItem', ServiceLocalItemFields)

export default Factory